import type {
	CreateTrustedIP,
	SetServerStatusInput,
	UpdateServerInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetServersOverview: undefined;
	useCreateServer: CreateTrustedIP;
	useUpdateServer: UpdateServerInput;
	useSetServerStatus: SetServerStatusInput;
	useReassignWorkers: undefined;
}

const SERVER_ADMIN_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"server-admin",
	[
		"useGetServersOverview",
		"useCreateServer",
		"useUpdateServer",
		"useSetServerStatus",
		"useReassignWorkers",
	],
);

export { SERVER_ADMIN_SERVICE_KEYS };
